import { ISvgProps } from '@src/types';

const OpenArrow = ({ width = '8px', height = '8px', fillColor = 'var(--font-color)', ...props }: ISvgProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 8 8"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M7.4,1.5896344 L7.4,5.89257813 C7.4,6.55531982 6.8627417,7.09257813 6.2,7.09257813 L1.89705627,7.09257813 C1.23431458,7.09257813 0.697056275,6.55531982 0.697056275,5.89257813 C0.697056275,5.57431834 0.823484483,5.26909364 1.04852814,5.04404999 L5.35147186,0.741106262 C5.82010101,0.272477112 6.57989899,0.272477112 7.04852814,0.741106262 C7.27357179,0.966149917 7.4,1.27137461 7.4,1.5896344 Z"
          id="Rectangle-5-Copy-2"
          fill={fillColor}
        ></path>
      </g>
    </svg>
  );
};

export default OpenArrow;
